export default __webpack_public_path__ + "static/media/privacyLight.0e0d8ab8.svg";